<template>
      <div class="container">
            <header class="page-header">
                <ol class="breadcrumb page-breadcrumb">
                   <li>
                        <router-link :to="{ name: 'home'}">Home</router-link>
                    </li>
                    <li class="active"> {{subCategoryMenu.ParentCategoryName}}</li>
                </ol>
            </header>
            <div class="row">
                <div class="col-md-3">
                    <aside class="category-filters">
                        <div class="category-filters-section">
                            <h3 class="widget-title-sm">
                                <router-link :to="{ name: 'servicesByCategory', params: { id: subCategoryMenu.ParentCategoryId }}">
                                {{subCategoryMenu.ParentCategoryName}}
                                </router-link>
                            </h3>
                            <ul class="cateogry-filters-list">
                                <li v-for="category in subCategoryMenu.CategoryList">
                                    <router-link :to="{ name: 'servicesByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </aside>
                </div>
                <div class="col-md-6">
                    <div class="row" data-gutter="15" v-for="service in servicesByCategory">
                        <div class="col-md-12">
                            <div class="product product-left ">
                                <div class="product-img-wrap">
                                    <img class="product-img-primary" v-bind:src="service.ItemImage" alt="Image Alternative text" title="Image Title" />
                                    <img class="product-img-alt" v-bind:src="service.ItemImage2" alt="Image Alternative text" title="Image Title" />
                                </div>
                                <div class="product-caption-category">
                                    <h5 class="product-caption-title-search">
                                        <router-link :to="{ name: 'service', params: { id: service.Id }}">{{service.Name}}</router-link>
                                    </h5>
                                    <div class="product-caption-price">
                                        <span class="product-caption-price-search">Category : {{service.Category}}</span>
                                    </div>
                                    <ul class="product-caption-feature-list-search">
                                        <li>{{service.ShortDescription}}</li>
                                    </ul>
                                    <div class="product-caption-category-co">
                                        <h5 class="product-caption-title-search-co">
                                            <router-link target="_blank" :to="{ name: 'company', params: { id: service.CompanyId }}">{{service.CompanyName}}</router-link>
                                        </h5>
                                        <ul class="product-caption-feature-list-title">
                                            <li>Location: {{service.Location}}</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <LatestTendersRfq></LatestTendersRfq>
            </div>
        </div>
</template>

<script>

import { mapState } from 'vuex'
import LatestTendersRfq from '@/components/LatestTendersRfq'

export default {
     components:{
        LatestTendersRfq
     },
     created() {
    	this.initView(this.$route.params.id)
      },
      computed: {
		...mapState({
            subCategoryMenu: state => state.categories.subServiceCategoryMenu,
            servicesByCategory: state => state.services.servicesByCategory
        })
    },
    watch:{
        $route (to, from){
           this.initView(this.$route.params.id)
        }
    },
    methods: {
        initView(categoryId) {
            this.$store.dispatch('categories/fetchServiceSubCategories', {categoryId: categoryId})
            this.$store.dispatch('services/fetchServicesByCategory', {categoryId: categoryId})
        }
    }
}
</script>
